import React from 'react';
import { withAuthenticator, useAuthenticator } from '@aws-amplify/ui-react';
import { useQuery } from '@tanstack/react-query';
import { API } from 'aws-amplify';
import { Row, Col } from 'react-bootstrap';
import clsx from 'clsx';
import LaunchpadCard from '../../components/LaunchpadCard';
import Images from '../../assets/images';
import Loading from '../../components/Loading';
import { getUserInfo } from '../../utils/helpers/getUserInfo';
import styles from './styles.module.scss';

const DashboardAnalytics = () => {
  const { user } = useAuthenticator((context) => [context.user]);
  const { token } = getUserInfo(user);

  const removeDuplicates = (arr, key) => {
    return [...new Map(arr.map(item => [item[key], item])).values()];
  };

  const { data, isLoading } = useQuery({
    queryKey: ['getConfigClientData', user, 'dashboard'],
    queryFn: async () => {
      const apiName = 'Routific_API';
      const path = `/get-config-client-data?email=${user.username}&type=dashboard`;
      const params = {
        headers: { Authorization: token },
      };
      const res = await API.get(apiName, path, params);
      if (!res.length) return [];
      const newArr = [];
      res?.map((config) => {
        const parseValue = config.value ? JSON.parse(config.value) : [];
        newArr.push(...parseValue);
        return parseValue;
      });
      localStorage.setItem('DASHBOARD_LIST_ITEM', JSON.stringify(newArr));
      return newArr.length ? removeDuplicates(newArr, 'id') : [];
    },
    enabled: !!user,
  });

  if (isLoading) return <Loading />;

  return (
    <div className={clsx(styles['analytics-wrapper'])}>
      <Row className={styles['analytics-grid']}>
        {data?.sort((a, b) => a.name.localeCompare(b.name)).map((dashboard) => (
          <Col key={dashboard.id} xs={12} sm={6} lg={3} className={styles['analytics-col']}>
            <LaunchpadCard
              icon={Images.SideBarDashboardItem}
              iconStyle={{}}
              title={dashboard.name}
              description={dashboard.description || `View the ${dashboard.name}`}
              to={`/${dashboard.id}`}
              scrollableDescription
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default withAuthenticator(DashboardAnalytics, {
  hideSignUp: true,
});
